import { IconSvg, IconSvgProps } from "./icon"

export default function CirclePlus(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 8.643v7.714M8.143 12.5h7.714M12 20.857a8.357 8.357 0 1 0 0-16.714 8.357 8.357 0 0 0 0 16.714Z" />
    </IconSvg>
  )
}
